import { toasts } from './components';

export async function copy(text: string): Promise<void> {
    await navigator.clipboard.writeText(text);
    toasts.success('Copied to clipboard');
}
